module.exports = "../../../../platform/assets/pageMainIcon/cd-status-2.svg";